import gql from 'graphql-tag';

export default gql`
    mutation SaveCustomer($input: SaveCustomerInput) {
        saveCustomer(input: $input) {
            errors
        }
    }
`;
